module.exports = __webpack_public_path__ + "static/media/IMG_6562_2.8f4e0b3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/photos/IMG_6562_2.jpg
// module id = 215
// module chunks = 0